// eslint-disable-next-line no-restricted-imports
import { SvgIcon, SvgIconProps } from '@mui/material';
import Svg from '@rhg/../public/_n/images/icons/profile_outline_avatar.svg';

export const ProfileOutlineAvatar = (props: SvgIconProps) => (
    <SvgIcon component={Svg} inheritViewBox {...props} />
);
